import Collapsible from "react-collapsible";
import ContentContainer from "./ContentContainer";
import SectionTitle from "./SectionTitle";
import classes from "../../scss/ServiceCollapsibleList.module.scss";
import SectionList from "./SectionList";
import { useState } from "react";

export default function CollapsibleList({ title, list, className = "" }) {
  const [open, setOpen] = useState(false);

  const Trigger = () => {
    return (
      <div className={classes.collapsible__trigger}>
        <SectionTitle title={title} className={classes.collapsible__title} />
        <span
          className={`${classes.collapsible__icon} ${
            open ? classes.collapsible__icon_active : ""
          }`}
        ></span>
      </div>
    );
  };

  return (
    <ContentContainer>
      <Collapsible
        classParentString={`${classes.collapsible || ""} ${className}`}
        trigger={<Trigger />}
        onOpening={() => setOpen(true)}
        onClosing={() => setOpen(false)}
      >
        <SectionList list={list} className={classes.collapsible__list} />
      </Collapsible>
    </ContentContainer>
  );
}
